import React from 'react';
import { Row, Col } from 'reactstrap';
import { InterviewQuestionRow } from '../../../containers/applicant_tracking/InterviewKits/InterviewKitPage/InterviewQuestionsBody/InterviewQuestionRow';
import { InterviewStageQuestion } from '../../../entities/applicant_tracking/InterviewStage';

interface PropTypes {
  questions: InterviewStageQuestion[];
}

export function InterviewKitQuestions(props: PropTypes) {
  const orderedQuestions = props.questions.sort((a, b) => {
    return a.order - b.order;
  });
  const numRows = Math.ceil(orderedQuestions.length / 2);
  const rowIndices = Array.from(Array(numRows).keys());

  return (
    <div className='mt-3 pt-1'>
      {rowIndices.map((index) => {
        return (
          <Row key={index}>
            <Col xs='6' className='d-flex flex-column'>
              <InterviewQuestionRow
                number={index + 1}
                question={orderedQuestions[index].question}
              />
            </Col>
            {orderedQuestions[index + numRows] && (
              <Col xs='6' className='d-flex flex-column'>
                <InterviewQuestionRow
                  number={index + numRows + 1}
                  question={orderedQuestions[index + numRows].question}
                />
              </Col>
            )}
          </Row>
        );
      })}
    </div>
  );
}
